import AuthLayout from "@/pages/auth/layout";
import OTPPage from "@/pages/auth/otp";
import OnboardingPage from "@/pages/auth/onboarding";
import AuthPage from "@/pages/auth";
import LoginPage from "@/pages/auth/login";
import ErrorBoundary from "@/components/ErrorBoundry";
// import AstrologerRegistration from "@/pages/auth/registration";

export const authRoutes = {
  path: "/auth",
  element: <AuthLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    { path: "/auth", element: <AuthPage /> },
    { path: "/auth/login", element: <LoginPage /> },
    { path: "/auth/otp", element: <OTPPage /> },
    { path: "/auth/onboarding", element: <OnboardingPage /> },
    // { path: "/auth/registration", element: <AstrologerRegistration /> },
  ],
};
